import {RouteRecordRaw} from "vue-router";
import HeaderView from "@/views/share/HeaderView.vue";
import MainSideView from "@/views/main/MainSideView.vue";
import MainContentView from "@/views/main/MainContentView.vue";
import LayoutView from "@/views/share/LayoutView.vue";
import {session} from "@/model/session";
import {Main} from "@/model/main";
import {Material} from "@/model/material";

export default <Array<RouteRecordRaw>>[
    {
        path: '/',
        name: '',
        meta: {auth: true},
        component: LayoutView,
        beforeEnter: async (to, _, next) => {
            try {
                to.meta.material = await session.material()
                to.meta.main = new Main(to.meta.material as Material)
            } catch (e) {
                console.error(e)
                // return next('/login');
            }
            return next()
        },
        children: [{
            path: '',
            name: 'main',
            meta: {auth: true},
            components: {
                default: MainContentView,
                side: MainSideView,
                header: HeaderView,
            },
        }]
    }
]